import L from "leaflet";
import "leaflet/dist/leaflet.css";

export class Map {
  constructor() {
    this.map = document.getElementById("map");
    this.markers = [];
    if (!this.map) return;
    this.bindSetupEvents();
  }

  bindSetupEvents() {
    this.init();
    this.addMarkers();
  }

  addMarkers() {
    if (!this.map.dataset.sites) return;

    const sites = JSON.parse(this.map.dataset.sites);
    sites.forEach((site) => {
      if (!site.latitude || !site.longitude) return;
      const customIcon = L.icon({
        iconUrl: "/app/themes/akyos-sage/resources/assets/icons/marker.svg",
        iconSize: [32, 40],
      });

      const marker = L.marker([site.latitude, site.longitude], {
        icon: customIcon,
      }).addTo(this.leaflet).on("click", () => {
        Livewire.dispatch("map:get-card", {
          siteId: site.id,
        });
      });
    });
  }

  init() {
    const rect = this.map.getBoundingClientRect();
    if (rect.width === 0 || rect.height === 0) {
      console.warn(
        "Le conteneur de la carte n'est pas visible, report de l'initialisation",
      );
      setTimeout(() => this.init(), 100);
      return;
    }

    this.leaflet = L.map(this.map).setView([47.0524, 4.3831], 8);

    L.tileLayer("http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}", {
      subdomains: ["mt0", "mt1", "mt2", "mt3"],
      maxZoom: 19,
      attribution: "© Google / Leaflet",
    }).addTo(this.leaflet);
  }
}
